<agr-summary-card [actions]="actions" [title]="'downyMildew.dashboardWidget.title' | translate">
  @if (store.hasDownyMildewPremium()) {
    <div class="content">
      @if (hasDownyMildewAdvices()) {
        <app-disease-dashboard-widget-header
          (selectedDatesChanges)="onSelectedDatesChange($event)"
          [lastCalculatedOnOverride]="store.downyMildewCalculationDate()"
          [maximalDateOverride]="maximalDate()"
          [minimalDateOverride]="store.downyMildewMinAdviceDate()"
          [cropYear]="store.cropYear()"
          [translationPrefix]="translationPrefix"
        />
        <mat-divider />
        <div class="buttons-section">
          @if (showAdviceButton()) {
            <button
              (click)="onViewAdvice()"
              class="w-100"
              color="primary"
              data-test="view-advice-button"
              mat-flat-button
            >
              {{ 'downyMildew.dashboardWidget.viewAdvice' | translate }}
            </button>
          }
          <button
            (click)="onAction()"
            [disabled]="isActionButtonDisabled()"
            [matMenuTriggerFor]="actionMenuTop.menu"
            class="action-button"
            color="accent"
            mat-flat-button
          >
            <app-downy-mildew-action-menu #actionMenuTop [advices]="selectedCropFieldAdvices()" />
            <mat-icon>add</mat-icon>
            {{ actionButtonLabel() }}
          </button>
          <app-recalculate-button
            (recalculate)="onRecalculate()"
            [disabled]="isRecalculationDisabled()"
            [disabledTooltip]="isCropYearReadOnly() ? ('UI.CurrentYearOnlyMutationMessage' | translate) : ''"
            [isLoading]="store.isDownyMildewCropFieldsSyncing()"
            [label]="'downyMildew.shared.recalculateAdviceAll' | translate"
          />
        </div>
        <div class="flex--row spacing--margin-vertical">
          <app-disease-dashboard-widget-table
            (selectedCropFieldsChanged)="onCropFieldSelectionChange($event)"
            [advices]="store.downyMildewAdvices()"
            [selectedDates]="selectedDates()"
            [translationPrefix]="translationPrefix"
            class="w-100"
          />
        </div>
        <button
          (click)="onAction()"
          [disabled]="isActionButtonDisabled()"
          [matMenuTriggerFor]="actionMenuBottom.menu"
          class="action-button"
          color="accent"
          mat-flat-button
        >
          <app-downy-mildew-action-menu #actionMenuBottom [advices]="selectedCropFieldAdvices()" />
          <mat-icon>add</mat-icon>
          {{ actionButtonLabel() }}
        </button>
        @if (showAdviceButton()) {
          <button
            (click)="onViewAdvice()"
            class="view-advice-button"
            color="primary"
            data-test="view-advice-button"
            mat-flat-button
          >
            {{ 'downyMildew.dashboardWidget.viewAdvice' | translate }}
          </button>
        }
      } @else if (store.downyMildewDataIsLoading()) {
        <div class="loading-state">
          <app-loading-spinner></app-loading-spinner>
        </div>
      } @else {
        <agr-notification-empty [isEmpty]="true" />
      }
    </div>
  } @else {
    <app-empty-widget [text]="'downyMildew.nonPremiumText' | translate" />
  }
</agr-summary-card>
